import { Tenant, TenantInstallation } from 'features/account/types'
import ProviderIcon from 'features/common/ui/ProviderIcon/ProviderIcon'
import { ProviderType } from 'features/connections'
import { FormattedMessage } from 'react-intl'
import { IntegrationType, BucketProvider } from '../types'

export const getIntegrationsCatalog = ({ tenant }: { tenant: Tenant }) => ({
  [IntegrationType.RedshiftImport]: {
    integrationType: IntegrationType.RedshiftImport,
    storageProvider: BucketProvider.S3,
    title: 'Redshift S3 Bucket',
    description: (
      <FormattedMessage
        id={
          tenant.installation === TenantInstallation.Saas
            ? 'integrations.redshift.subtitle.saas'
            : 'integrations.redshift.subtitle.onprem'
        }
      />
    ),
    icon: <ProviderIcon provider={ProviderType.REDSHIFT} />
  },

  [IntegrationType.ExternalIdp]: {
    integrationType: IntegrationType.ExternalIdp,
    title: <FormattedMessage id="integrations.externalIdp.title" />,
    description: <FormattedMessage id="integrations.externalIdp.description" />,
    icon: <ProviderIcon provider={ProviderType.SNOWFLAKE} />
  },

  [IntegrationType.PostgresRdsExport]: {
    integrationType: IntegrationType.PostgresRdsExport,
    storageProvider: BucketProvider.S3,
    title: 'RDS for PostgreSQL S3 Bucket',
    description: <FormattedMessage id="integrations.postgresExport.subtitle" />,
    icon: <ProviderIcon provider={ProviderType.POSTGRES} />
  },
  [IntegrationType.BQWorkloadIdentityFederation]: {
    integrationType: IntegrationType.BQWorkloadIdentityFederation,
    title: 'Workload Identity Federation for BigQuery',
    description: <FormattedMessage id="integrations.workloadsIdentityFederation.tableDescription" />,
    icon: <ProviderIcon provider={ProviderType.BIGQUERY} />
  },
  [IntegrationType.DatabricksOAuthU2M]: {
    integrationType: IntegrationType.DatabricksOAuthU2M,
    title: <FormattedMessage id="integrations.oauthU2mDatabricks.title" />,
    description: <FormattedMessage id="integrations.oauthU2mDatabricks.subtitle" />,
    icon: <ProviderIcon provider={ProviderType.DATABRICKS} />
  }
})
